// Canonical mirror of Natlink design tokens. Each entry resolves to a CSS variable
// declared in `styles/tokens.css` (light) and overridden under `[data-theme="dark"]`
// (dark). Using `var(--nl-*)` strings here means React inline styles automatically
// re-render with the right value when the theme attribute on <html> flips.
export const COLORS = {
  // Primary
  primary:                 "var(--nl-primary)",
  onPrimary:               "var(--nl-on-primary)",
  primaryContainer:        "var(--nl-primary-container)",
  onPrimaryContainer:      "var(--nl-on-primary-container)",
  primaryFixed:            "var(--nl-primary-fixed)",
  onPrimaryFixed:          "var(--nl-on-primary-fixed)",
  primaryFixedDim:         "var(--nl-primary-fixed-dim)",
  onPrimaryFixedVariant:   "var(--nl-on-primary-fixed-variant)",
  inversePrimary:          "var(--nl-inverse-primary)",

  // Secondary
  secondary:               "var(--nl-secondary)",
  onSecondary:             "var(--nl-on-secondary)",
  secondaryContainer:      "var(--nl-secondary-container)",
  onSecondaryContainer:    "var(--nl-on-secondary-container)",
  secondaryFixed:          "var(--nl-secondary-fixed)",
  onSecondaryFixed:        "var(--nl-on-secondary-fixed)",
  secondaryFixedDim:       "var(--nl-secondary-fixed-dim)",
  onSecondaryFixedVariant: "var(--nl-on-secondary-fixed-variant)",

  // Tertiary
  tertiary:                "var(--nl-tertiary)",
  onTertiary:              "var(--nl-on-tertiary)",
  tertiaryContainer:       "var(--nl-tertiary-container)",
  onTertiaryContainer:     "var(--nl-on-tertiary-container)",
  tertiaryFixed:           "var(--nl-tertiary-fixed)",
  onTertiaryFixed:         "var(--nl-on-tertiary-fixed)",
  tertiaryFixedDim:        "var(--nl-tertiary-fixed-dim)",
  onTertiaryFixedVariant:  "var(--nl-on-tertiary-fixed-variant)",

  // Error
  error:                   "var(--nl-error)",
  onError:                 "var(--nl-on-error)",
  errorContainer:          "var(--nl-error-container)",
  onErrorContainer:        "var(--nl-on-error-container)",

  // Surface ramp
  surface:                 "var(--nl-surface)",
  surfaceDim:              "var(--nl-surface-dim)",
  surfaceBright:           "var(--nl-surface-bright)",
  surfaceContainerLowest:  "var(--nl-surface-container-lowest)",
  surfaceContainerLow:     "var(--nl-surface-container-low)",
  surfaceContainer:        "var(--nl-surface-container)",
  surfaceContainerHigh:    "var(--nl-surface-container-high)",
  surfaceContainerHighest: "var(--nl-surface-container-highest)",
  onSurface:               "var(--nl-on-surface)",
  onSurfaceVariant:        "var(--nl-on-surface-variant)",
  outline:                 "var(--nl-outline)",
  outlineVariant:          "var(--nl-outline-variant)",
  inverseSurface:          "var(--nl-inverse-surface)",
  inverseOnSurface:        "var(--nl-inverse-on-surface)",

  scrim:                   "var(--nl-scrim)",
  disabled:                "var(--nl-disabled)",

  // Opacity overlays
  primaryOpacity8:         "var(--nl-primary-opacity-8)",
  primaryOpacity12:        "var(--nl-primary-opacity-12)",
  primaryOpacity38:        "var(--nl-primary-opacity-38)",
  onPrimaryOpacity8:       "var(--nl-on-primary-opacity-8)",
  onPrimaryOpacity12:      "var(--nl-on-primary-opacity-12)",
  onSurfaceOpacity8:       "var(--nl-on-surface-opacity-8)",
  onSurfaceOpacity12:      "var(--nl-on-surface-opacity-12)",

  fontDisplay: "var(--nl-font-display)",
} as const;

export type ColorTokens = typeof COLORS;
